module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAiIGhlaWdodD0iMTUwIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTIyIDIwLjdMMy4zIDJMMiAzLjNsMSAxVjE5YzAgMS4xLjkgMiAyIDJoMTQuN2wxIDFsMS4zLTEuM001IDE5VjYuM2w3LjYgNy42bC0xLjUgMS45TDkgMTMuMUw2IDE3aDkuN2wyIDJINU04LjggNWwtMi0ySDE5YzEuMSAwIDIgLjkgMiAydjEyLjJsLTItMlY1SDguOCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-off-outline.svg
// module id = Reoy
// module chunks = 1